import { cn, PropsWithClassName } from "kz-ui-sdk";
import { PropsWithChildren, ReactNode } from "react";

interface FormTitleProps extends PropsWithChildren, PropsWithClassName {
  title: string;
  subTitle: string | ReactNode;
  classes?: {
    title?: string;
    subTitle?: string;
  };
}

const FormTitle = ({ title, subTitle, classes, className }: FormTitleProps) => {
  return (
    <div className={cn("flex flex-col items-center", className)}>
      <h1 className={cn("h-[32px] text-2xl font-semibold text-content-base", classes?.title)}>{title}</h1>
      <span className={cn("text-xs leading-5 text-content-soft", classes?.subTitle)}>{subTitle}</span>
    </div>
  );
};

export default FormTitle;
